<template>
  <div
    v-if="password"
    class="password-strength"
  >
    <v-progress-linear
      :value="percentage"
      :color="color"
      height="6"
      rounded
      class="mt-1"
    />
    <div class="d-flex justify-space-between align-center mt-1">
      <small :class="`${color}--text font-weight-medium`">
        Seguridad: {{ label }}
      </small>
      <small class="grey--text">{{ score }}/{{ checks.length }}</small>
    </div>
    <ul
      v-if="pendingChecks.length"
      class="password-strength__pending mt-1 mb-0"
    >
      <li
        v-for="check in pendingChecks"
        :key="check.label"
      >
        {{ check.label }}
      </li>
    </ul>
  </div>
</template>

<script>
  import { passwordChecks, passwordScore } from '@/utils/passwordRules'

  export default {
    name: 'PasswordStrength',
    props: {
      password: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        checks: passwordChecks,
      }
    },
    computed: {
      score () {
        return passwordScore(this.password)
      },
      percentage () {
        return (this.score / this.checks.length) * 100
      },
      pendingChecks () {
        return this.checks.filter(check => !check.test(this.password))
      },
      label () {
        return ['Muy debil', 'Muy debil', 'Debil', 'Regular', 'Buena', 'Fuerte'][this.score]
      },
      color () {
        return ['red', 'red', 'deep-orange', 'amber', 'light-green', 'green'][this.score]
      },
    },
  }
</script>

<style lang="scss" scoped>
.password-strength__pending {
  list-style: none;
  padding-left: 0;

  li {
    font-size: 12px;
    color: #757575;

    &::before {
      content: '• ';
    }
  }
}
</style>
